import React, { useEffect } from "react";
import Slider from "../../common/Slider";
import Slider1 from "../sliders/Slider1";
import Slider2 from "../sliders/Slider2";
import Slider3 from "../sliders/Slider3";
import Advantage from "./Advantage";
import About from "./About";
import Services from "./Services";
import Achievement from "./Achievement";
import Testimonial from "./Testimonial";
import Team from "../about/Team";

function Home({ setTab }) {
  useEffect(() => {
    setTab("home");
  }, [setTab]);
  return (
    <>
      <Slider
        sliders={[
          <Slider1 setTab={setTab} />,
          <Slider2 setTab={setTab} />,
          <Slider3 setTab={setTab} />,
        ]}
      />
      <div className="site-main">
        <Advantage setTab={setTab} />
        <About />
        <Services setTab={setTab} />
        <Achievement />
        <Team setTab={setTab} />
        <Testimonial setTab={setTab} />
      </div>
    </>
  );
}

export default Home;
